import clsx from 'clsx';
import Txt from 'components/atoms/Txt/Txt';
import PageHeader from 'components/molecules/PageHeader/PageHeader';
import { MORE } from 'components/pages/pages';
import React from 'react';
import classes from './PrivacyNotice.qmee.module.scss';

export interface Props {
  className?: string;
}

const PrivacyNotice: React.FC<Props> = ({ className }) => {
  return (
    <article className={clsx(className, classes.root)}>
      <PageHeader title="Privacy Notice" backHref={MORE.path} />
      <Txt asMarkdown component="div">
        privacy-policy.markdown
      </Txt>
    </article>
  );
};
export default PrivacyNotice;
